<template>
<div class="jkl">
    <el-container style="height: 1250px; border: 1px solid #eee; margin:0 10% 0 10%">
    <el-container> 
    <el-main>
        <h1 style="font-size:30px; margin-top: 8px">推荐产品</h1>
        <a href="http://www.sysytf.net/Chanpin"> 
        <div class="demo-image__preview">
          <el-image style="width: 1100px; height: 250px;" :src="require('../assets/chanpinshow.png')">
          </el-image>
        </div>
        </a>
        <h1 style="font-size:30px; margin-top: 45px; margin-bottom: 10px">关于三源</h1>
        <div style="display: flex; justify-content: flex-start;">
          <div style="width: 700px">
            <p class="context">绍兴上虞三源通风设备有限公司成立于2005年，位于中国风机之乡的绍兴市上虞区，公司地处长三角经济圈杭州湾经济区，104国道京兰线旁，毗邻常台高速入口，地理位置优越，交通便捷。</p>
            <p class="context">公司产品规格齐全，主要产品包括离心风机、屋顶风机、排烟风机、轴流风机等，以及其他风机配件产品。公司产品设计先进、制造设备精良、检测手段完善，公司生产产品通过国家3C标准认证。</p>
            <p class="context">我们始终坚持“用户至上”的经营宗旨，本着“下一道工序就是用户”的工作态度，用优质的产品立足于市场。在十几年的努力中，上虞三源全体员工锐意进取，以高品质的风机产品、优质的服务赢得了广大客户的信任与好评。</p>
        </div>
        <div>
          <img style="width: 450px; height: 250px; margin-left: 30px" :src="require('@/assets/fengmian/damen.png')"/>
        </div>
        </div>
        <h1 style="font-size:30px; margin-top: 45px; margin-bottom: 10px">资质证书</h1>
        <a href="http://www.sysytf.net/Zhengshu">
          <marquee width="1100" height="400" vspace="10" hspace="10" loop="infinite" behavior="alternate"
           onmouseover=this.stop() onmouseout=this.start()  scrollamount=2>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/1.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/2.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/3.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/4.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/5.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/6.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/7.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/8.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/9.jpg')"/>
          <img style="width: 300px; height: 400px; margin-left: 30px" :src="require('@/assets/zhengshu/10.jpg')"/>
        </marquee> 
        </a>
    </el-main>
  </el-container>
</el-container>
</div>   
</template>

<script>
  export default {
    data() {
      return {
        urls: [
          require("../assets/chanpin/1.jpg"),
          require("../assets/chanpin/2.jpg"),
          require("../assets/chanpin/3.jpg"),
          require("../assets/chanpin/4.jpg"),
          require("../assets/chanpin/5.jpg"),
          require("../assets/chanpin/6.jpg"),
          require("../assets/chanpin/7.jpg"),
          require("../assets/chanpin/8.jpg"),
          require("../assets/chanpin/9.jpg"),
          require("../assets/chanpin/10.jpg"),
          require("../assets/chanpin/11.jpg"),
          require("../assets/chanpin/12.jpg"),
        ]
      }
    }
  }
</script>

<style scoped>

.fenge {
    width: 95px;
    margin-top: 0;
    margin-left: 15px;
    background-color: rgb(24, 140, 179);
    border: rgb(24, 140, 179);
    box-shadow: 0 0 0 0;
}

.title {
    font-size: 200%;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
}

.context {
  text-indent: 2em; 
  line-height:25px; 
  margin-top: 7px; 
  margin-bottom: 7px; 
  font-size:18px;
}

</style>
